<template>
  <div id="header" class="flex_sw">
    <div class="header_left" @click="handleHome">
      <img src="@/assets/images/header/logo.png" alt="" />
    </div>
    <div class="header_right flex_start">
      <div class="header_list flex_start">
        <div class="header_list_item" v-for="item in navList" :key="item.id">
          <div
            :class="[
              'header_list_item_title',
              navId == item.id ? 'header_list_item_title_active' : '',
            ]"
            @click="handleTo(item)"
          >
            {{ languageZh == "cn" ? item.name : item.name_en }}
          </div>
          <div class="header_list_item_posi" v-if="item.child.length > 0">
            <div class="header_list_item_posi_abs">
              <div style="background-color: #f9f9f9">
                <div class="header_list_item_posi_abs_list">
                  <div
                    :class="[
                      'header_list_item_posi_abs_item',
                      items.id == navChildId
                        ? 'header_list_item_posi_abs_item_active'
                        : '',
                    ]"
                    v-for="items in item.child"
                    :key="items.id"
                    @click="handleTo(items)"
                  >
                    {{ languageZh == "cn" ? items.name : items.name_en }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="search1"
        @click="
          searchFlag = true;
          search = '';
        "
        src="@/assets/images/header/search1.png"
        alt=""
      />
      <div class="language">
        <div class="language_img flex_center">
          <img src="@/assets/images/header/diqiu.png" alt="" />
        </div>
        <div class="language_posi">
          <div class="language_posi_abs">
            <div
              :class="[
                languageZh == item.zh
                  ? 'language_posi_abs_item language_posi_abs_item_active'
                  : 'language_posi_abs_item',
              ]"
              v-for="item in languageList"
              :key="item.id"
              @click="handleLanguage(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="header_phone flex_center">
        <img src="@/assets/images/header/phone.png" alt="" />
        <div>{{ phone }}</div>
      </div>
    </div>
    <div class="a-static a-display">
      <div class="language">
        <div class="language_img flex_center">
          <img src="@/assets/images/header/diqiu.png" alt="" />
        </div>
        <div class="language_posi">
          <div class="language_posi_abs">
            <div
              :class="[
                languageZh == item.zh
                  ? 'language_posi_abs_item language_posi_abs_item_active'
                  : 'language_posi_abs_item',
              ]"
              v-for="item in languageList"
              :key="item.id"
              @click="handleLanguage(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="mk-nav-responsive-link" @click="handleH5">
        <div class="mk-css-icon-menu">
          <div class="mk-css-icon-menu-line-1"></div>
          <div class="mk-css-icon-menu-line-2"></div>
          <div class="mk-css-icon-menu-line-3"></div>
        </div>
      </div>
    </div>
    <div class="h5-nav">
      <ul class="layui-nav layui-nav-tree">
        <li class="layui-nav-item" v-for="item in navList" :key="item.id">
          <a
            href="javascript:;"
            v-if="item.child.length == 0"
            @click.stop="handleTo(item)"
            >{{ languageZh == "cn" ? item.name : item.name_en }}</a
          >
          <a href="javascript:;" v-else>{{
            languageZh == "cn" ? item.name : item.name_en
          }}</a>
          <dl class="layui-nav-child" v-if="item.child.length > 0">
            <a
              href="javascript:;"
              v-for="items in item.child"
              :key="items.id"
              :class="[items.id == navChildId ? 'layui-nav-child-ac' : '']"
              @click.stop="handleTo(items)"
              >{{ languageZh == "cn" ? items.name : items.name_en }}</a
            >
          </dl>
        </li>
      </ul>
      <div class="search_from">
        <form>
          <input
            class="text-input"
            @keydown.enter="handleSearch"
            type="text"
            v-model="search"
            :placeholder="
              languageZh == 'cn' ? '请输入关键词' : 'Please enter keywords'
            "
          />
          <i class="mk-searchform-icon" @click="handleSearch">
            <img src="@/assets/images/header/search2.png" alt="" />
          </i>
        </form>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="posi_fixed flex_center" v-if="searchFlag">
      <div class="search_main">
        <div class="search_input">
          <input
            @keydown.enter="handleSearch"
            type="text"
            v-model="search"
            :placeholder="
              languageZh == 'cn' ? '请输入关键词' : 'Please enter keywords'
            "
          />
          <img
            @click="handleSearch"
            src="@/assets/images/header/search2.png"
            alt=""
          />
        </div>
        <i
          class="el-icon-close"
          @click.stop="
            searchFlag = false;
            search = '';
          "
        ></i>
      </div>
    </div>
    <!-- 左边侧边栏 -->
    <div class="drawer">
      <div class="drawer_list">
        <!-- <div class="drawer_item" @click="handleOnline">
          <div class="drawer_item_main">
            <img src="@/assets/images/header/l1.png" alt="" />
            <div>{{ languageZh == "cn" ? "在线客服" : "Online Service" }}</div>
          </div>
        </div> -->
        <div class="drawer_item">
          <div class="drawer_item_main">
            <img src="@/assets/images/header/l2.png" alt="" />
            <div>{{ languageZh == "cn" ? "电话咨询" : "contact" }}</div>
            <div class="drawer_item_posi">
              <div class="drawer_item_posi_pd">{{ phone }}</div>
            </div>
          </div>
        </div>
        <div class="drawer_item">
          <div class="drawer_item_main">
            <img src="@/assets/images/header/l3.png" alt="" />
            <div>{{ languageZh == "cn" ? "微信咨询" : "weixin" }}</div>
            <div class="drawer_item_posi">
              <div class="drawer_item_posi_pd">
                <img src="@/assets/images/header/weixin.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="drawer_item">
          <div class="drawer_item_main" @click="handleTop">
            <img src="@/assets/images/header/l4.png" alt="" />
            <div>{{ languageZh == "cn" ? "返回顶部" : "Back to top" }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchFlag: false,
      search: "",
      navList: [],
      languageList: [
        {
          id: 1,
          name: "中文",
          zh: "cn",
        },
        {
          id: 2,
          name: "ENGLISH",
          zh: "en",
        },
      ],
      navId: 1,
      navChildId: "",
      languageZh: localStorage.getItem("zh") || "cn",
      phone: "",
    };
  },
  mounted() {
    this.indexGetallcate();
  },
  methods: {
    //得到所有栏目数据
    async indexGetallcate() {
      let res = await this.$api.indexGetallcate();
      if (res.code == 1) {
        this.navList = [
          {
            id: 0,
            name: "首页",
            name_en: "Home",
            route: "/",
            child: [],
          },
          ...res.data,
        ];
        this.$nextTick(() => {
          layui.use(function () {
            var element = layui.element;
            element.render("nav");
          });
        });
      }
    },
    //
    handleLanguage(item) {
      this.languageZh = item.zh;
      window.localStorage.setItem("zh", item.zh);
      location.reload();
    },
    handleTo(item) {
      this.$router.push(item.route);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (window.innerWidth < 680) {
        this.handleH5();
      }
    },
    handleH5() {
      $(".mk-nav-responsive-link").toggleClass("dashboard-active");
      if ($(".mk-nav-responsive-link").hasClass("dashboard-active")) {
        $(".h5-nav").css({ display: "block" });
        $(".a-static").css({ "box-shadow": "none" });
      } else {
        $(".h5-nav").css({ display: "none" });
        // $(".a-static").css({ "box-shadow": "0 1px 8px rgba(126, 0, 0, 0.36)" });
      }
    },
    handleSearch() {
      this.$router.push(`/search?keyword=${this.search}`);
      this.searchFlag = false;
      if (window.innerWidth < 680) {
        this.handleH5();
      }
    },
    handleTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleHome(){
      this.$router.push("/");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleOnline() {
      window.open(
        "https://wpa.qq.com/wpa_jump_page?v=3&uin=0000000000&site=qq&menu=yes"
      );
    },
  },
  watch: {
    $route: {
      handler(newVal) {
        console.log(newVal);
        this.navId = newVal.meta.fatherId;
        this.navChildId = newVal.meta.id;
        if (this.$route.query.child_id) {
          this.navChildId = this.$route.query.child_id;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
#header {
  width: 100%;
  height: 0.469rem;
  background-color: #fff;
  position: fixed;
  padding: 0 0.172rem 0 0.286rem;
  z-index: 99;
  .header_left {
    img {
      width: 0.833rem;
      height: 0.255rem;
      cursor: pointer;
    }
  }
  .header_right {
    .header_list {
      .header_list_item {
        min-width: 0.365rem;
        margin-right: 0.365rem;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        .header_list_item_title {
          font-size: 0.083rem;
          color: #333;
          cursor: pointer;

          &:hover {
            color: #e5322d;
          }
        }
        .header_list_item_title_active {
          color: #e5322d;
        }
        &:hover {
          .header_list_item_posi {
            // transform: translate(0,0);
            opacity: 1;
            display: block;
          }
        }
      }
    }
    .search1 {
      width: 0.099rem;
      height: 0.099rem;
      margin: 0 0.458rem;
      cursor: pointer;
    }
    .language {
      margin-right: 0.219rem;
      position: relative;
      cursor: pointer;
      &:hover {
        .language_posi {
          display: block;
        }
      }
      .language_img {
        width: 0.219rem;
        height: 0.219rem;
        background-color: #f0f0f0;
        border-radius: 50%;
        img {
          width: 0.115rem;
          height: 0.115rem;
        }
      }
      .language_posi {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        display: none;

        .language_posi_abs {
          width: 0.625rem;
          border-radius: 0.031rem;
          background-color: rgba(255, 255, 255, 0.8);
          padding-top: 0.125rem;
          .language_posi_abs_item {
            height: 0.188rem;
            font-size: 0.073rem;
            color: #666;
            text-align: center;
            line-height: 0.188rem;
            &:hover {
              background-color: #e5322d;
              color: #fff;
            }
            &:first-child {
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            }
          }
          .language_posi_abs_item_active {
            background-color: #e5322d;
            color: #fff;
          }
        }
      }
    }
    .header_phone {
      font-size: 0.083rem;
      width: 1.042rem;
      height: 0.219rem;
      background-image: linear-gradient(270deg, #e5322d 0%, #ff7558 100%),
        linear-gradient(#e5322d, #e5322d);
      background-blend-mode: normal, normal;
      border-radius: 0.109rem;
      color: #fff;
      img {
        width: 0.083rem;
        height: 0.083rem;
        margin-right: 0.052rem;
      }
    }
  }
}
.posi_fixed {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
  .search_main {
    position: relative;
    .search_input {
      position: relative;
      input {
        width: 5.729rem;
        height: 0.292rem;
        line-height: 0.135rem;
        background-color: #ffffff;
        border-radius: 28px;
        box-sizing: border-box;
        font-size: 0.078rem;
        color: #333;
        padding-left: 0.104rem;
        padding-right: 0.26rem;
        outline: none;
        border: none;
      }
      img {
        position: absolute;
        right: 0.109rem;
        top: 50%;
        transform: translate(0, -50%);
        width: 0.099rem;
        height: 0.099rem;
        cursor: pointer;
      }
    }
    i {
      position: absolute;
      color: #fff;
      font-size: 0.125rem;
      right: 0;
      top: 0;
      transform: translate(100%, -100%);
      cursor: pointer;
    }
  }
}
.drawer {
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 20;
  .drawer_list {
    .drawer_item {
      cursor: pointer;
      margin-bottom: 8px;
      .drawer_item_main {
        font-size: 0.083rem;
        display: flex;
        align-items: center;
        color: #fff;
        width: 0.677rem;
        padding: 0.073rem 0 0.073rem 0.052rem;
        background-color: #e5322d;
        border-radius: 26px 0px 0px 26px;
        transform: translate((66%), 0);
        transition: all 0.5s;
        position: relative;
        &:hover {
          transform: translate(0, 0);
          .drawer_item_posi {
            display: block;
          }
        }
        img {
          width: 0.146rem;
          height: 0.146rem;
          margin-right: 0.052rem;
        }
        .drawer_item_posi {
          position: absolute;
          left: 0;
          transform: translate(-100%, 0);
          padding-right: 10%;
          display: none;
          .drawer_item_posi_pd {
            display: flex;
            align-items: center;
            min-height: 0.313rem;
            color: #fff;
            font-size: 0.125rem;
            padding: 0.052rem 0.104rem;
            font-weight: bold;
            white-space: nowrap;
            top: 0.052rem;
            border-radius: 0.052rem;
            background-color: #e5322d;
            &::before {
              content: "";
              border-color: transparent transparent transparent #e5322d;
              border-style: dashed dashed dashed solid;
              border-width: 0.052rem;
              position: absolute;
              top: 50%;
              right: -0.021rem;
              margin-top: -0.052rem;
              transition: all 0.2s ease;
            }
            img {
              width: 0.729rem;
              height: 0.729rem;
              display: block;
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
.header_list_item_posi {
  position: fixed;
  left: 0;
  top: 0.286rem;
  display: none;
  width: 100%;
  // transform: translate(-120%,0);
  opacity: 0;
  transition: all 0.3s;
  .header_list_item_posi_abs {
    width: 100%;
    // background-color: rgba(255, 255, 255, 0.8);
    padding-top: 0.125rem;
    .header_list_item_posi_abs_list {
      display: flex;
      flex-wrap: wrap;
      width: 6.438rem;
      padding: 0.313rem 0 0.234rem;
      margin: 0 auto;
    }
    .header_list_item_posi_abs_item {
      width: calc(99.9% / 3);
      margin-bottom: 0.245rem;
      color: #333333;
      font-size: 0.094rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      &::before {
        display: block;
        content: "";
        width: 0.026rem;
        height: 0.026rem;
        flex-shrink: 0;
        margin-right: 0.031rem;
        background-color: #333;
        border-radius: 50%;
      }
      &:hover {
        color: #e5322d;
        cursor: pointer;
        &::before {
          background-color: #e5322d;
        }
      }
    }
    .header_list_item_posi_abs_item_active {
      color: #e5322d;
      cursor: pointer;
      &::before {
        background-color: #e5322d;
      }
    }
  }
  &:hover {
  }
}
.h5-nav {
  display: none;
}
.a-display {
  display: none;
}
@media (max-width: 680px) {
  .a-display {
    display: flex;
    align-items: center;
  }
  #header {
    width: 100%;
    height: 64px;
    background-color: #fff;
    position: fixed;
    padding: 0 30px;
    z-index: 99;
    .header_left {
      img {
        width: 100px;
        height: auto;
      }
    }
    .header_right {
      display: none;
    }
    .language {
      margin-right: 20px;
      position: relative;
      cursor: pointer;
      &:hover {
        .language_posi {
          display: block;
        }
      }
      .language_img {
        width: 32px;
        height: 32px;
        background-color: #f0f0f0;
        border-radius: 50%;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .language_posi {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        display: none;

        .language_posi_abs {
          width: 120px;
          border-radius: 6px;
          background-color: rgba(255, 255, 255, 0.8);
          padding-top: 16px;
          .language_posi_abs_item {
            height: 36px;
            font-size: 14px;
            color: #666;
            text-align: center;
            line-height: 36px;
            &:hover {
              background-color: #e5322d;
              color: #fff;
            }
            &:first-child {
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            }
          }
          .language_posi_abs_item_active {
            background-color: #e5322d;
            color: #fff;
          }
        }
      }
    }
    .mk-nav-responsive-link {
      transition: all 0.15s ease-in-out;
      -webkit-perspective: 1000;
    }
    .mk-css-icon-close div,
    .mk-css-icon-menu div {
      background-color: #ff6464;
    }

    .mk-css-icon-close div,
    .mk-css-icon-menu div {
      height: 3px;
      margin-bottom: 3px;
      border-radius: 3px;
      display: block;
      position: relative;
    }

    .mk-css-icon-menu-line-1,
    .mk-css-icon-menu-line-3 {
      transition: all 0.2s ease;
    }

    .mk-css-icon-menu-line-2 {
      transition: opacity 0.1s ease;
    }

    .mk-css-icon-close,
    .mk-css-icon-menu {
      width: 18px;
      height: 18px;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }

    .mk-nav-responsive-link {
      cursor: pointer;
      padding: 10px;
      transition: all 0.15s ease-in-out;
      -webkit-perspective: 1000;
    }

    .dashboard-active .mk-css-icon-menu-line-1,
    .is-active .mk-css-icon-menu-line-1 {
      transform: rotate3d(0, 0, 1, 45deg);
      top: 6px;
    }

    .dashboard-active .mk-css-icon-menu-line-2,
    .is-active .mk-css-icon-menu-line-2 {
      opacity: 0;
    }

    .dashboard-active .mk-css-icon-menu-line-3,
    .is-active .mk-css-icon-menu-line-3 {
      transform: rotate3d(0, 0, 1, -45deg);
      top: -6px;
    }
    .h5-nav {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 64px;
      left: 0;
      z-index: 201;
      // padding-top: 64px;
      box-sizing: border-box;
    }

    .h5-nav .layui-nav {
      background-color: #fff;
    }

    .h5-nav .layui-nav.layui-nav-tree {
      width: 100%;
    }

    .h5-nav .layui-nav-tree .layui-nav-item {
      background-color: #fff;
    }

    .h5-nav .layui-nav-tree .layui-nav-item a {
      color: #444;
      font-weight: bold;
      font-size: 13px;
      background-color: #fff;
      border-bottom: 1px solid rgba(128, 128, 128, 0.2);
      display: flex;
      align-items: center;
    }

    .h5-nav .layui-nav-itemed > a,
    .h5-nav .layui-nav-tree .layui-nav-title a,
    .h5-nav .layui-nav-tree .layui-nav-title a:hover {
      color: #444 !important;
    }

    .h5-nav .layui-nav-tree .layui-nav-child {
      background-color: #fff;
      padding: 0;
    }

    .h5-nav .layui-nav .layui-nav-item a:hover,
    .h5-nav .layui-nav .layui-this a {
      color: #444;
      background-color: rgba(0, 0, 0, 0.03);
    }
    .h5-nav .layui-nav .layui-nav-child a:hover {
      color: #e5322d !important;
      background-color: #fff !important;
    }
    .h5-nav .layui-nav .layui-nav-child-ac {
      color: #e5322d !important;
      background-color: #fff !important;
    }
    .h5-nav .layui-nav-tree .layui-nav-bar {
      display: none;
    }

    .h5-nav .layui-nav-tree .layui-nav-child a {
      border-bottom: none;
      font-size: 12px;
      font-weight: normal;
    }

    .h5-nav .search_from {
      padding: 10px;
      box-sizing: border-box;
      background-color: #fff;
    }

    .h5-nav .search_from form {
      position: relative;
    }

    .h5-nav .search_from_tips {
      font-size: 16px;
      margin-bottom: 20px;
      font-size: 16px;
      color: #666666;
      text-align: center;
    }

    .h5-nav .text-input {
      font-size: 13px;
      color: #767676;
      margin: 0;
      padding: 12px 28px 12px 15px;
      width: 100%;
      border: 2px solid rgba(0, 0, 0, 0.12);
      background-color: #fdfdfd;
      box-sizing: border-box;
    }

    .h5-nav .search_from form i {
      position: absolute;
      top: 13px;
      right: 14px;
      opacity: 0.4;
    }

    .h5-nav .search_from form i .search-button {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      outline: 0;
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
  }
  .posi_fixed {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 999;
    .search_main {
      position: relative;
      .search_input {
        position: relative;
        input {
          width: 5.729rem;
          height: 0.292rem;
          line-height: 0.135rem;
          background-color: #ffffff;
          border-radius: 28px;
          box-sizing: border-box;
          font-size: 0.078rem;
          color: #333;
          padding-left: 0.104rem;
          padding-right: 0.26rem;
          outline: none;
          border: none;
        }
        img {
          position: absolute;
          right: 0.109rem;
          top: 50%;
          transform: translate(0, -50%);
          width: 0.099rem;
          height: 0.099rem;
          cursor: pointer;
        }
      }
      i {
        position: absolute;
        color: #fff;
        font-size: 0.125rem;
        right: 0;
        top: 0;
        transform: translate(100%, -100%);
        cursor: pointer;
      }
    }
  }
  .drawer {
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 20;
    .drawer_list {
      .drawer_item {
        cursor: pointer;
        margin-bottom: 8px;
        .drawer_item_main {
          font-size: 14px;
          display: flex;
          align-items: center;
          color: #fff;
          width: 120px;
          padding: 14px 14px 10px;
          background-color: #e5322d;
          border-radius: 26px 0px 0px 26px;
          transform: translate((66%), 0);
          transition: all 0.5s;
          position: relative;
          &:hover {
            transform: translate(0, 0);
            .drawer_item_posi {
              display: block;
            }
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          .drawer_item_posi {
            position: absolute;
            left: 0;
            transform: translate(-100%, 0);
            padding-right: 10%;
            display: none;
            .drawer_item_posi_pd {
              display: flex;
              align-items: center;
              min-height: 40px;
              color: #fff;
              font-size: 16px;
              padding: 10px 12px;
              font-weight: bold;
              white-space: nowrap;
              top: 10px;
              border-radius: 10px;
              background-color: #e5322d;
              &::before {
                content: "";
                border-color: transparent transparent transparent #e5322d;
                border-style: dashed dashed dashed solid;
                border-width: 10px;
                position: absolute;
                top: 50%;
                right: -4px;
                margin-top: -10px;
                transition: all 0.2s ease;
              }
              img {
                width: 100px;
                height: 100px;
                display: block;
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
  .header_list_item_posi {
    position: fixed;
    left: 0;
    top: 0.286rem;
    display: none;
    width: 100%;
    // transform: translate(-120%,0);
    opacity: 0;
    transition: all 0.3s;
    .header_list_item_posi_abs {
      width: 100%;
      // background-color: rgba(255, 255, 255, 0.8);
      padding-top: 0.125rem;
      .header_list_item_posi_abs_list {
        display: flex;
        flex-wrap: wrap;
        width: 6.438rem;
        padding: 0.313rem 0 0.234rem;
        margin: 0 auto;
      }
      .header_list_item_posi_abs_item {
        width: calc(100% / 3);
        margin-bottom: 0.245rem;
        color: #333333;
        font-size: 0.094rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        &::before {
          display: block;
          content: "";
          width: 0.026rem;
          height: 0.026rem;
          flex-shrink: 0;
          margin-right: 0.031rem;
          background-color: #333;
          border-radius: 50%;
        }
        &:hover {
          color: #e5322d;
          cursor: pointer;
          &::before {
            background-color: #e5322d;
          }
        }
      }
      .header_list_item_posi_abs_item_active {
        color: #e5322d;
        cursor: pointer;
        &::before {
          background-color: #e5322d;
        }
      }
    }
    &:hover {
    }
  }
}
</style>